/* eslint-disable import/no-default-export */
import React, { Suspense } from 'react';

import { useSelector } from 'react-redux';

import {
  OverlayType,
  OverlayContext,
} from 'app/gamma/src/modules/state/ui/overlay';
import { State } from 'app/gamma/src/modules/types';
import {
  getActiveOverlay,
  getOverlayContext,
} from 'app/gamma/src/selectors/overlays';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ReduxProvider } from 'app/src/components/ReduxProvider';

const Overlays = () => {
  let component;

  const PlanSelectionOverlay = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "plan-selection-overlay" */ './plan-selection-overlay'
      ),
    {
      preload: false,
    },
  );
  const overlay = useSelector((state: State) => getActiveOverlay(state));
  const context: OverlayContext = useSelector((state: State) =>
    getOverlayContext(state),
  );

  switch (overlay) {
    case OverlayType.PlanSelection:
      component = context?.orgId && (
        <PlanSelectionOverlay orgId={context?.orgId} />
      );
      break;
    default:
      component = null;
  }

  return <Suspense fallback={null}>{component}</Suspense>;
};

const WithReduxProvider = () => {
  return (
    <ReduxProvider>
      <Overlays />
    </ReduxProvider>
  );
};

export default WithReduxProvider;
